import React from "react";

/** InfoRetrieval brand mark — transparent SVG for dark backgrounds. Magnifier over a court-column crest, gold accent. */
export function BrandLogo({ className = "", withWordmark = true, light = true }) {
  const ink = light ? "#ffffff" : "#0b1f3a";
  const sub = light ? "#e8b04b" : "#2d7bd0";
  return (
    <svg viewBox="0 0 640 160" className={className} role="img" aria-label="InfoRetrieval" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="ir-gold" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#f3c66b" /><stop offset="1" stopColor="#d99a2b" /></linearGradient>
      </defs>
      <g transform="translate(6 8)">
        <path d="M72 6 L132 30 V74 C132 106 106 130 72 142 C38 130 12 106 12 74 V30 Z" fill="#0b1f3a" stroke={ink} strokeWidth="6" strokeLinejoin="round" />
        <path d="M34 56 H110 M40 56 V98 M58 56 V98 M86 56 V98 M104 56 V98 M30 98 H114" stroke={ink} strokeWidth="6" strokeLinecap="round" opacity=".55" />
        <circle cx="86" cy="66" r="26" fill="#0b1f3a" stroke="url(#ir-gold)" strokeWidth="9" />
        <path d="M104 86 L128 112" stroke="url(#ir-gold)" strokeWidth="12" strokeLinecap="round" />
        <path d="M74 66 a12 12 0 0 1 12 -12" stroke="#fff" strokeWidth="4" strokeLinecap="round" fill="none" opacity=".9" />
      </g>
      {withWordmark && (
        <g>
          <text x="166" y="86" fontFamily="'Plus Jakarta Sans', 'IBM Plex Sans', system-ui, sans-serif" fontWeight="800" fontSize="66" letterSpacing="-2" textLength="440" lengthAdjust="spacingAndGlyphs" fill={ink}>Info<tspan fill={sub}>Retrieval</tspan></text>
          <text x="170" y="120" fontFamily="'IBM Plex Sans', system-ui, sans-serif" fontWeight="600" fontSize="14" letterSpacing="3" textLength="440" lengthAdjust="spacingAndGlyphs" fill={ink} opacity=".78">DELAWARE PROCESS SERVICE &amp; INVESTIGATIONS</text>
        </g>
      )}
    </svg>
  );
}
